import {Component} from "react"

export default class AbsoluteRedirect extends Component {
    componentWillMount() {
        window.location = this.props.to
    }
}
